import '@styles/app.pcss';
import header from '@commons/header';
import main from '@commons/main';
import FaqSearch from '@vue-instances/FaqSearch';

export default function init() {
  // Commons
  header();
  main();

  // Vue instances
  FaqSearch();
}

init();
